import * as React from "react";

import { IWrappedComponent, observer } from 'mobx-react';

import { withGoogleMap, GoogleMap, Marker as GMarker, GoogleMapProps } from "react-google-maps";

import Marker from "./Marker";

//2017-jun-1 markg: uses this react component for google maps
//https://github.com/tomchentw/react-google-maps
//however, I've provided a lot of defaults to suit
//how we use it in C4K

const WrappedGoogleMap = withGoogleMap(
	(props: any) => <GoogleMap
		ref={props.ref}
		{...props}
	>
		{props.markers}
	</GoogleMap>
);

interface MyGoogleMapProps extends GoogleMapProps {
	height: string;

	onMapLoad?: (map: any) => void;
};

type MyGoogleMapState = {

};

@observer
class MyGoogleMap extends React.Component<MyGoogleMapProps, MyGoogleMapState> {

	constructor(props, context) {
		super(props, context);
	}

	map: any;

	render() {
		var props = this.props;

		var mapOptions = {

			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,

			mapTypeControl: false,

			//2015-mar-18 markg: hide some of the clickable points of interest,
			// so that users don't accidentally tap them and display conflicting info windows
			// see: http://stackoverflow.com/a/7337629
			styles: [
				{
					"featureType": "poi.attraction",
					"stylers": [
						{ "visibility": "off" }
					]
				}, {
					"featureType": "poi.business",
					"stylers": [
						{ "visibility": "off" }
					]
				}, {
					"featureType": "poi.sports_complex",
					"stylers": [
						{ "visibility": "off" }
					]
				}, {
					"featureType": "transit",
					"stylers": [
						{ "visibility": "off" }
					]
				}, {
					"featureType": "poi.government",
					"stylers": [
						{ "visibility": "off" }
					]
				}
			]
		};

		var markers = null;

		if (React.Children.count(props.children) > 0) {

			markers = React.Children.map(props.children, o => {

				//2021-apr-16 markg: the default React.ReactNode doesn't seem to support the type and props properties
				//can't seem to cast to React.ReactChild either
				const child: any = o;

				if (child.type === Marker) {
					var gMarker = <GMarker {...child.props} ref={child.ref} />

					return gMarker;

				} else {
					return null;
				}

			}).filter(o => o != null);
		}

		var propsLessChildren = {};

		var propertyNames = Object.keys(props);

		for (var i = 0; i < propertyNames.length; i++) {
			var propName = propertyNames[i];

			if (propName == "children") continue;

			propsLessChildren[propName] = props[propName];
		}

		return (
			<WrappedGoogleMap
				ref={r => { this.map = r; if (props.onMapLoad) { props.onMapLoad(r); } }}
				containerElement={
					<div style={{ height: props.height }} />
				}
				mapElement={
					<div style={{ height: props.height }} />
				}
				options={mapOptions}
				{...props}
				markers={markers}
			/>

		);
	}
}

export default MyGoogleMap;